import { PHONE_NUMBER } from '@/constants/Common'
import { LocaleEvent } from '../en/event'

const event: LocaleEvent = {
  showUnclaimedAccountsDesc:
    'Las cuentas que no se pueden seleccionar no han sido reclamadas o han sido invitadas. Los jugadores afectados deben registrarse para poder ser seleccionados',
  events: 'Eventos',
  eventsNearMe: 'Eventos Cerca de Mí',
  myEvents: 'Mis Eventos',
  explore: 'Explorar',
  eventStatus: 'Estado del Evento',
  addABracket: 'Agregar un Cuadro de Competencia',
  editEvent: 'Editar Evento',
  endEvent: 'Finalizar Evento',
  addAnAnnouncement: 'Agregar un Anuncio',
  submitPayment: 'Enviar Pago',
  register: 'Registrarse',
  registrationClosed: 'Registro Cerrado',
  registered: 'Registrado',
  aboutTheEvent: 'Acerca del Evento',
  announcements: 'Anuncios',
  noMoreAnnouncements: 'No hay más anuncios.',
  eventRegistration: 'Registro al Evento',
  clubMembership: 'Membresía del Club',
  clubMembershipQuestion: '¿Eres miembro del club anfitrión?',
  contactDetails: 'Detalles de Contacto',
  selectYourBrackets: 'Selecciona tus Cuadros de Competencia',
  competitionDates: 'Fechas de Competición',
  invitedPlayer: 'Jugador Invitado',
  invitedPlayerTooltip:
    "Has sido invitado a este evento por tu compañero. Para aceptar o rechazar esta invitación, por favor ve a la sección 'mis brackets' de tu panel de jugador.",
  ineligibleBracket: 'Cuadro Inelegible',
  registrationFull: 'Registro Completo',
  registerForWaitlist: 'Registrarse en Lista de Espera',
  totalPaymentDue: 'Pago Total Pendiente (1 Evento)',
  inviteSent: 'Invitación Enviada',
  offers: 'Ofertas',
  eventPolicies: 'Políticas del Evento',
  iAgreeText: 'He leído y acepto la',
  healthAndSafetyPolicy: 'Política de Salud y Seguridad',
  liabilityPolicy: 'Política de Responsabilidad',
  registeredSuccessfully: 'Ya has pagado e registrado exitosamente.',
  registrationComplete: 'Registro Completo',
  registrationCompleteText:
    'Tu registro está completo. Puedes editar los detalles desde la página de inicio de tu cuadro, accesible desde el panel.',
  continueToPayment: 'Continuar al Pago',
  addPhoneNumber: 'Agregar Número de Teléfono',
  editPhoneNumber: 'Editar Número de Teléfono',
  bracketDetails: 'Detalles del Cuadro',
  players: 'Jugadores',
  teams: 'Equipos',
  matches: 'Partidos',
  partnerConfirmed: 'Pareja Confirmada',
  noPartnerSelected: 'Sin Pareja Seleccionada',
  partnerPending: 'Pareja Pendiente',
  viewDraws: 'Ver Emparejamientos',
  seedMatches: 'Sortear Partidos',
  editBracket: 'Editar Cuadro',
  endBracket: 'Finalizar Cuadro',
  endBracketModalDesc: 'No podrás realizar cambios en este bracket una vez que elijas marcarlo como completado.',
  withdraw: 'Retirarse',
  editPartner: 'Editar Pareja',
  removePartner: 'Eliminar Pareja',
  removePartnerFirstDesc: '¿Estás seguro de que deseas rechazar la',
  removePartnerSendDesc: 'invitación para jugar en este evento?',
  addPartner: 'Añadir Compañero',
  reopenBracket: 'Reabrir Cuadro',
  confirmWithdrawFromBracket: '¿Estás seguro de que quieres retirarte de este cuadro?',
  contactTheEventOrganizer: 'Si planeas solicitar un reembolso, contacta al organizador del evento antes de retirarte.',
  toRegisterFor: 'Para registrarse en',
  answerCompleteThePrecess: 'Ingresa los siguientes detalles para completar el proceso.',
  declineInvite: 'Rechazar invitación',
  declineInviteFirstDesc: '¿Estás seguro de que deseas rechazar la',
  declineInviteSecondDesc: 'invitación para jugar en este evento?',
  exitTheQueue: 'Salir de la Cola',
  exitTheQueueDesc:
    'Sal de la cola si has encontrado una cancha para tu próxima partida. La cancha debe estar disponible y debes estar físicamente en la cancha una vez que elijas salir de la cola.',
  WL: 'G/P',
  pointDiff: 'Diferencia de Puntos',
  waitlisted: 'En Lista de Espera',
  switchBracket: 'Cambiar Cuadro',
  switchBrackets: 'Cambiar Cuadros',
  switch: 'Cambiar',
  addParticipant: 'Agregar Participante',
  switchBracketsConfirmation: '¿Estás seguro de que quieres cambiar de cuadro para el equipo seleccionado?',
  withdrawPlayer: 'Retirar Jugador',
  confirmWithdrawPlayerFirstText: '¿Estás seguro de que quieres eliminar',
  confirmWithdrawPlayerSecondText: 'de este cuadro?',
  withdrawRefund: 'Retirar/Reembolsar',
  addABracketParticipant: 'Agregar Participante a Cuadro',
  selectAPlayer: 'Selecciona un jugador de la lista a continuación.',
  memberOfHostClub: '¿Es el jugador miembro del club anfitrión?',
  selectBracketsToSwitch: 'Seleccionar cuadros para cambiar',
  confirmTeam: 'Confirmar Equipo',
  editTeam: 'Editar Equipo',
  splitTeam: 'Dividir Equipo',
  replace: 'Reemplazar',
  addAPartner: 'Agregar Pareja',
  addAPartnerDesc:
    'Si tu pareja ya es usuario de DUPR, puedes agregarlos a tu equipo buscándolos en este directorio. Si tu pareja no está registrada en DUPR, puedes invitarlos a tu equipo por correo electrónico.',
  teamConfirmed: 'Equipo Confirmado',
  teamPending: 'Equipo Pendiente',
  replaceTeamDesc:
    'Puedes reemplazar este equipo registrado con cualquier equipo en lista de espera para este cuadro. Una vez que hagas una selección, las partidas se reorganizarán automáticamente en los cuadros de origen y destino. Selecciona de los equipos mencionados a continuación.',
  confirmEditTeam: '¿Estás seguro de que quieres editar el equipo?',
  confirmThisTeams: '¿Estás seguro de que quieres confirmar este equipo?',
  createTeam: 'Crear Equipo',
  playersDifferentGenders: 'Los jugadores deben ser de diferentes géneros',
  unmatchedTeams: 'Equipos No Emparejados',
  pleaseSelectAnyTwoPlayers: 'Selecciona a dos jugadores de esta lista para crear un equipo',
  youSelectedTwoPlayersSameGender:
    'Seleccionaste a dos jugadores del mismo género. Debido a que este es un cuadro mixto, todos los equipos deben contener un jugador masculino y uno femenino.',
  thisTeamCannotCreated: 'Este equipo no se puede crear porque',
  and: 'y',
  isOnTheWaitlist: 'están en la lista de espera. Crea un equipo con jugadores no en lista de espera.',
  afterYouConfirm: "Después de confirmar esta selección, estos jugadores se moverán a la pestaña 'equipos'",
  forfeit: 'Forfeit',
  bye: 'Bye',
  forfeitMatch: 'Forfeit de Partida',
  forfeitMatchDesc:
    'Selecciona al equipo que ha perdido por forfeit. El equipo que elijas será considerado como perdedor de la partida.',
  teamA: 'Equipo A',
  teamB: 'Equipo B',
  markAsForfeit: 'Marcar Como Forfeit',
  youCanAddScores: 'Puedes agregar puntajes entre estas fechas',
  titleSubmitScoreModal: 'Enviar Puntajes para Todas las Partidas',
  scoreWarningMessage:
    'Debes completar la partida y enviar los puntajes para todas las partidas de una vez. Si planeas enviar puntajes para partidas adicionales en esta partida, regresa.',
  editingScoresTitle: 'Editando los puntajes de un evento completado',
  editingScoresFirstDesc:
    'Estás editando los puntajes de un evento completado. Las clasificaciones y las partidas futuras de este evento no se verán afectadas.',
  editingScoresSecondDesc: ' You will loose the integrity of data in Diagram and standings of this event. ',
  stillContinue: '¿Aún quieres continuar?',
  submitScores: 'Enviar Puntajes',
  submittingScoresTitle: 'Enviar estos nuevos puntajes afectará las partidas programadas',
  submittingScoresFirstDesc: 'Elegiste un nuevo ganador, algunas partidas en la siguiente ronda se reprogramarán.',
  editScores: 'Editar Puntajes',
  addScores: 'Agregar Puntajes',
  deleteBracketMatchDesc:
    'Si eliminas esta partida, tendrás que comenzar de nuevo para ingresar puntajes y que afecten tu clasificación.',
  validateMatch: 'Validar Partida',
  validate: 'Validar',
  substitutes: 'Suplentes',
  selectParticipant: 'Selecciona un participante de la lista a continuación.',
  totalAmountPaid: 'Cantidad Total Pagada',
  showDetail: 'Mostrar Detalle',
  playerStatus: 'Estado del Jugador',
  paymentStatus: 'Estado del Pago',
  amountPaid: 'Cantidad Pagada',
  amountRefunded: 'Cantidad Reembolsada',
  bracketName: 'Nombre del Cuadro',
  pricing: 'Precios',
  pricingDesc:
    'Los jugadores deben pagar una tarifa de inscripción al evento más una tarifa por cuadro para participar en un evento. El precio del evento también puede variar dependiendo de si eres miembro del club anfitrión.',
  eventEntryFee: 'Tarifa de Inscripción',
  bracketPrice: 'Precio del Cuadro',
  importantDates: 'Fechas Importantes',
  importantDatesDesc:
    'Los jugadores deben pagar una tarifa de inscripción al evento más una tarifa por cuadro para participar en un evento. El precio del evento también puede variar dependiendo de si eres miembro del club anfitrión.',
  registrationDates: 'Fechas para Registrarse',
  registrationLimit: 'Límite para Registrarse',
  numberTeamsPermitted: 'Número de equipos permitidos',
  waitlistAllowance: 'Limite de Lista de Espera',
  allowedWaitlist: 'Equipos permitidos en la lista de espera',
  bracketType: 'Tipo de Cuadro',
  roundRobin: 'Round Robin',
  roundRobinDesc:
    'Un torneo de round-robin es una competición en la que cada concursante se enfrenta a todos los demás concursantes a su vez. Un round-robin contrasta con un torneo de eliminación, en el que los participantes son eliminados después de cierto número de derrotas.',
  waterfall: 'Cascada',
  waterfallDesc:
    'The 16 team waterfall tournament format ensures that each team plays exactly 4 matches. The bracket is labeled with the 8 directions on a compass(North, South, East, West, Northeast, Northwest, Southeast, and Southwest). For every match, each team plays against a team with the exact same sequence of wins and losses.',
  flexLeague: 'Liga Flexible',
  flexLeagueDesc:
    'Las Ligas Flexibles DUPR, similares a los round robins, son competiciones en las que cada concursante se enfrenta a todos los demás concursantes a su vez. Los jugadores organizan partidos a su antojo, y estos eventos suelen tener lugar durante períodos de tiempo prolongados.',
  numberCourts: 'Número de Canchas',
  playerGroup: 'Grupo de Jugadores',
  playerRules: 'Reglas de Jugadores',
  skillLevel: 'Nivel de Habilidad',
  ageGroup: 'Grupo de Edad',
  menDoubles:
    'Los jugadores competirán en equipos de dos. Cada equipo debe estar compuesto por 2 jugadores masculinos.',
  womenDoubles:
    'Los jugadores competirán en equipos de dos. Cada equipo debe estar compuesto por 2 jugadoras femeninas.',
  mixedDoubles:
    'Los jugadores competirán en equipos de dos. Cada equipo debe estar compuesto por un jugador femenino y uno masculino.',
  openDoubles:
    'Los jugadores competirán en equipos de dos. Los jugadores pueden ser de cualquier combinación de género.',
  acceptPartner: 'Aceptar Compañero',
  leagueConsentTitle: 'Tu Información de Contacto Será Compartida',
  leagueConsentDesc:
    'Una vez que te registres para este evento, tu correo electrónico y número de teléfono serán visibles solo para los otros jugadores registrados para el evento. Esto permite a los jugadores contactarse entre sí para programar partidos.',
  noQualifyingBrackets: 'Sin Cuadros de Clasificación',
  noQualifyingBracketsTitle:
    'No calificas para ningún cuadro abierto dentro de este evento según tu calificación DUPR, edad y perfil de género.',
  pleaseContactEventAdministrator: 'Por favor, contacta al administrador del evento en',
  pleaseContactText: 'si crees que esto es un error.',
  step1: 'Paso 1: Por favor selecciona una opción y continúa',
  refundOnly: 'Solo Reembolso',
  withdrawAndRefund: 'Retirarse y Reembolso',
  step2: 'Paso 2',
  event: 'Evento',
  bracketsOf: 'cuadros de',
  total: 'Total',
  paymentPending: 'Pago Pendiente',
  freeEvent: 'Evento Gratuito',
  fullyRefundedEvent: 'Evento Totalmente Reembolsado',
  partiallyRefundedEvent: 'Evento Parcialmente Reembolsado',
  fullyRefunded: 'Totalmente Reembolsado',
  splitTeamFirst: 'Equipo Dividido Primero',
  freeBracket: 'Cuadro Gratuito',
  partiallyRefunded: 'Parcialmente Reembolsado',
  viewQualifyingPartners: 'Ver Compañeros Clasificados',
  viewQualifyingPartnersDesc:
    'Esta lista de usuarios de DUPR solo mostrará posibles compañeros que califiquen para este cuadro según su calificación, edad y género declarados.',
  joiningWaitlist: 'Te estás uniendo a una Lista de Espera',
  joiningWaitlistDesc:
    'Has optado por unirte a la lista de espera para al menos uno de tus cuadros. La administración de la liga te notificará si sales de la lista de espera.',
  fromSelectedBrackets: 'de los cuadros seleccionados?',
  sureRefundATotalAmount: '¿Estás seguro de que quieres reembolsar un monto total de',
  sureRemove: '¿Estás seguro de que quieres eliminar',
  seedMatchesDesc: "Presiona 'Sortear partidos' para emparejar a los Equipos",
  createMatches: 'Crear Partidos',
  seeds: 'Sortear',
  reseedMatches: 'Re-sortear Partidos',
  bracketCreated: 'Cuadro Creado.',
  endEventModalDesc:
    'Ya no podrás realizar cambios en este evento una vez que elijas marcarlo como completado. El evento será marcado como inactivo permanentemente.',
  endEventTitleModal: '¿Estás seguro de que quieres finalizar este evento?',
  reopenBracketDesc:
    'Una vez que reabras este cuadro, podrás agregar puntajes y editar información hasta la fecha de finalización del cuadro.',
  addABracketParticipantDesc:
    'Las cuentas que no se pueden seleccionar están sin reclamar/invitadas. Los jugadores afectados deben registrarse para poder ser seleccionados.',
  youLikeToCreateTeam: '¿Estás seguro de que quieres crear este equipo?',
  submittingScoresSecondDesc:
    "Si los jugadores ya están en la cancha y no deseas editar los emparejamientos actuales, haz clic en 'Volver'. Siempre puedes editar los resultados de los partidos individuales después de que se complete el evento. Si deseas continuar con los nuevos emparejamientos, Envía Resultados.",
  validateMatchDesc: `¿Estás seguro de que quieres validar estos puntajes? Si es así, la partida se finalizará y las clasificaciones de los jugadores se actualizarán. Si estos puntajes no son correctos, por favor contacta al director del evento o envía un mensaje de texto al ${PHONE_NUMBER} con los puntajes correctos.`,
  endBracketModalTitle: '¿Estás seguro de que quieres finalizar este cuadro?',
  moveToUnmatchedTab:
    'Después de retirar a este jugador, será movido a la pestaña de Jugadores No Emparejados. Desde allí, puedes agregar a este jugador a otro equipo o retirarlo completamente del evento.',
}

export default event
